"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Operator;
(function (Operator) {
    Operator["AbsIsMoreThan"] = "absIsMoreThan";
    Operator["DecreasedByMoreThan"] = "decreasedByMoreThan";
    Operator["IncreasedByMoreThan"] = "increasedByMoreThan";
})(Operator = exports.Operator || (exports.Operator = {}));
exports.OperatorKey = {
    increasedByMoreThan: 'OPERATOR.INCREASE',
    decreasedByMoreThan: 'OPERATOR.DECREASE',
    absIsMoreThan: 'OPERATOR.INCREASE_OR_DECREASE',
};
//# sourceMappingURL=operator.js.map